import { render } from "./PayoutDetail.vue?vue&type=template&id=796b2a34&ts=true"
import script from "./PayoutDetail.vue?vue&type=script&lang=ts"
export * from "./PayoutDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__